import { Checkbox, DatePicker, Form, Input, InputNumber, Result, Select } from "antd";
import { useForm } from "antd/es/form/Form";
import { FC, useState } from "react";
import { FCRodinaButton } from "../../components/Button";
import dayjs from "dayjs";
import { regRequest } from "../../api/transport/common";
//import { regRequest } from "../../../api/transport/common";
//import { RegType } from "../../../types/common";

interface RegFormValues {
    year: number;
    phoneNumber: string;
    schools: string;
}

interface RegFormProps { }

export const RegForm: FC<RegFormProps> = () => {
    const [form] = useForm<RegFormValues>();
    const [completed, setCompleted] = useState(false);
    const [error, setError] = useState(false);

    const onFormReset = () => {
        setCompleted(false);
        setError(false);
        if (!error) {
            form.resetFields();
        }
    }

    const onFormFinish = (values: RegFormValues) => {
        try {
            regRequest({
                ...values,
            });
            setCompleted(true);
        } catch (e) {
            setError(true);
        }
    }

    if (completed) {
        return (
            <Result
                status='success'
                title='Заявка отправлена'
                subTitle='Ваша заявка отправлена на рассмотрение'
            />
        )
    } else if (error) {
        return (
            <Result
                status='error'
                title='Отправить заявку не удалось'
                subTitle='Пожалуйста, попробуйте заполнить форму заново или воспользуйтесь контактным e-mail'
                extra={[
                    <FCRodinaButton key='reset' size='large' onClick={onFormReset}>Попробовать еще раз</FCRodinaButton>
                ]}
            />
        )
    }

    return (
        <div className='mx-auto w-full max-w-96 pb-8'>
            <h2 className="text-center pb-8 text-xl font-medium">Краткая информация</h2>
            <Form
                form={form}
                onFinish={onFormFinish}
                size="large"
                layout="vertical"
                className="w-full pb-8"
            >
                <Form.Item
                    label='Год рождения'
                    name='year'
                    rules={[{ required: true, message: 'Введите год рождения' }]}
                >
                    <InputNumber placeholder="2008" min={2008} max={2020} />
                </Form.Item>
                <Form.Item
                    label='Номер телефона'
                    name='phoneNumber'
                    rules={[{ required: true, message: 'Укажите номер телефона' }, {
                        pattern: /^[\+]?[0-9]+$/g,
                        message: 'Допускаются только + и цифры'
                    }]}
                >
                    <Input type="tel" allowClear placeholder="+70000000000" maxLength={20} />
                </Form.Item>
                <Form.Item
                    label='Футбольные школы'
                    name='schools'
                    rules={[{ required: true, message: 'Заполните данные о школах' }]}
                >
                    <Input.TextArea allowClear placeholder="Футбольные школы, в которых занимался" />
                </Form.Item>
                {/*<Form.Item
                    label=" "
                    colon={false}
                    name='consent'
                    valuePropName="checked"
                    rules={[{ required: true, message: 'Подтвердите согласие' }]}
                >
                    <Checkbox>
                        Я согласен c <a rel="noopener" href="https://fcrodina.com/static/docs/PrivacyPolicy.docx" target="_blank">политикой конфиденциальности</a>
                    </Checkbox>
                </Form.Item>*/}
            </Form>

            <div className="flex justify-center w-full">
                <FCRodinaButton size="medium" className="w-full !rounded-full transition-all active:scale-95" onClick={() => form.submit()}>Отправить</FCRodinaButton>
            </div>
        </div>
    );
}